import getCookie from "../get/getCookie.js";



/**
 * Возвращает куки с указанным именем или undefined, если ничего не найдено.
 * Дополнительно очищает значение от подозрительных слов (защита от XSS) и проверяет длину.
 *
 * @param {string} name - Имя искомой куки
 * @returns {string|undefined}
 */
const getSanitizedCookie = (name) => {
    let value = getCookie(name);

    if (!value) return undefined;

    // Вырезаем потенциально опасные конструкции
    value = value.replace(/script|urlencode|alert|fetch|document|cookie|onload|onerror|urldecode|%3c|%3e|confirm|console|<|>|src|href|alt|eval|domain/ig, "");

    if (!value) return undefined; // если после вырезания ничего не осталось

    if (value.length > 100) {
        return undefined; // если больше 100 символов, тоже возвращаем undefined
    }

    return value;
};

export default getSanitizedCookie;